import { TOGGLE } from "./actionTypes";

export const toggleAction = (isOpen: boolean) => {
    return {
        type: TOGGLE,
        payload: isOpen
    };
} 
